import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { SEOHead } from "./components/SEOHead";
import Home from "./pages/Home";
import WhatIsNFL from "./pages/WhatIsNFL";
import Rules from "./pages/Rules";
import Positions from "./pages/Positions";
import Strategy from "./pages/Strategy";
import Statistics from "./pages/Statistics";
import History from "./pages/History";
import HowToWatch from "./pages/HowToWatch";
import Glossary from "./pages/Glossary";
import FAQ from "./pages/FAQ";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";

function App() {
  return (
    <div className="min-h-screen bg-slate-950">
      <BrowserRouter>
        <SEOHead />
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/que-es-nfl" element={<WhatIsNFL />} />
          <Route path="/reglas" element={<Rules />} />
          <Route path="/posiciones" element={<Positions />} />
          <Route path="/estrategia" element={<Strategy />} />
          <Route path="/estadisticas" element={<Statistics />} />
          <Route path="/historia" element={<History />} />
          <Route path="/como-ver" element={<HowToWatch />} />
          <Route path="/glosario" element={<Glossary />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
